import React, { useEffect } from "react";
import { Icon, Tooltip } from "@shared/components";
import * as AccountStore from "@containers/Account/store";
import { useDispatch, useSelector } from "react-redux";
import { formatNumberWithCommas } from "@shared/utils";
import { actions as sharedActions } from "@shared/store";

import "./index.scss";

const Wallet: React.FC = () => {
  const dispatch = useDispatch();
  const account = useSelector(AccountStore.selectors.getActiveAccount());
  const credits = account?.credits || 0;

  useEffect(() => {
    dispatch(sharedActions.getUserDetails.request());
  }, [dispatch]);

  return (
    <Tooltip
      html
      position="bottom-end"
      content={
        <div>
          Dataflik is no longer supported and wallet top-ups are disabled.
          <br />
          Please use{" "}
          <a
            style={{
              color: "#1e57c7",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            target="_blank"
            href="https://www.datasift.ai/"
            rel="noreferrer"
          >
            DataSift - Real Estate Sales and Marketing
          </a>
          <br />
          to access your new account and continue using the service.
        </div>
      }
    >
      <div className="wallet">
        <div className="balance">
          <Icon type="wallet-grey" className="icons-wallet" />
          <div className="total inactive">${formatNumberWithCommas(credits / 100)}</div>
        </div>
      </div>
    </Tooltip>
  );
};

export default Wallet;
